import { render, staticRenderFns } from "./DataSources.vue?vue&type=template&id=bac5b180&scoped=true&"
import script from "./DataSources.vue?vue&type=script&lang=js&"
export * from "./DataSources.vue?vue&type=script&lang=js&"
import style0 from "./DataSources.vue?vue&type=style&index=0&id=bac5b180&lang=scss&scoped=true&"
import style1 from "./DataSources.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac5b180",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomSheet,VIcon})
